import type { CSSProperties } from 'react';

type RevealOptions = {
  base?: number;
  step?: number;
  // Caps the per-index delay. For short, fixed sections leave it off; for
  // open-ended lists (e.g. a "load more" archive) set it so the cascade stays
  // snappy instead of growing to multi-second delays at high indices.
  max?: number;
  className?: string;
};

// className + style for the staggered "rise-in" block entrance (see .anim-rise
// in index.css). `index` is the block's slot in its cascade; the delay grows as
// base + index*step (ms), optionally capped at `max`. This is the standard
// section-entrance treatment — spread it onto the top-level blocks of any new
// screen to keep motion uniform.
export function revealProps(
  index: number,
  { base = 60, step = 60, max, className }: RevealOptions = {},
): { className: string; style: CSSProperties } {
  const delay = base + index * step;
  return {
    className: className ? `anim-rise ${className}` : 'anim-rise',
    style: { animationDelay: `${max != null ? Math.min(delay, max) : delay}ms` },
  };
}
